import { LatLng } from '@hero/schema';

/** Returns true if coords are a valid non-default location (not 0,0) */
export const isValidCoords = (
  coords: LatLng | undefined,
): coords is { lat: number; lng: number } => {
  return Boolean(coords && (coords.lat !== 0 || coords.lng !== 0));
};
